import { Component, Injector } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { GlobalLoaderComponent } from '@features/loader/loader.component';
import { UiToastComponent } from '@akmf/ngx-ui-lib';
import { AppInjector } from '@core/classes/app.injector';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, GlobalLoaderComponent, UiToastComponent],
    templateUrl: './app.component.html'
})
export class AppComponent {
  constructor(injector: Injector) {
    AppInjector.injector = injector;
  }
}
